export const actionTypes = {
  R: '(Resubmit): Make appropriate changes and re-submit the claim',
  I: '(Information): Information only, or update your records accordingly',
  Q: '(Query): Submit a formal query.',
  'R/Q':
    'If the claim data submitted was incorrect, submit a new claim with correction. If the claim data submitted was correct and re-assessment is required, submit a formal query with supportive information.',
  '': '',
};
